export const categories = [
    {
      title: "OLX Autos (Cars)",
      items: ["CARS"],
    },
    {
      title: "Properties",
      items: [
        "For Sale: Houses & Apartments",
        "For Rent: Houses & Apartments",
        "Lands & Plots",
        "For Rent: Shops & Offices",
        "For Sale: Shops & Offices",
        "PG & Guest Houses",
      ],
    },
    {
      title: "Mobiles",
      items: ["Mobile Phones", "Accessories", "Tablets for Mobile"],
    },
    {
      title: "Jobs",
      items: [
        "Data entry & Back office",
        "Sales & Marketing",
        "BPO & Telecaller",
        "Driver",
        "Office Assistant",
        "Delivery & Collection",
        "Teacher",
        "Cook",
        "Receptionist & Front office",
        "Operator & Technician",
        "IT Engineer & Developer",
        "Hotel & Travel Executive",
        "Accountant",
        "Designer",
        "Other Jobs",
      ],
    },
    {
      title: "Bikes",
      items: ["Motorcycles", "Scooters", "Spare Parts", "Bicycles"],
    },
    {
      title: "Electronics & Appliances",
      items: [
        "TVs, Video - Audio",
        "Kitchen & Other Appliances",
        "Computers & Laptops",
        "Cameras & Lenses",
        "Games & Entertainment",
        "Fridges",
        "Computer Accessories",
        "Hard Disks, Printers & Monitors",
        "ACs",
        "Washing Machines",
      ],
    },
    {
      title: "Commercial Vehicles & Spares",
      items: ["Commercial Vehicles", "Other Vehicles", "Spare Parts"],
    },
    {
      title: "Furniture",
      items: [
        "Sofa & Dining",
        "Beds & Wardrobes",
        "Home Decor & Garden",
        "Kids Furniture",
        "Other Household Items",
      ],
    },
    {
      title: "Fashion",
      items: ["Men", "Women", "Kids"],
    },
    {
      title: "Books, Sports & Hobbies",
      items: [
        "Books",
        "Gym & Fitness",
        "Musical Instruments",
        "Sports Equipment",
        "Other Hobbies",
      ],
    },
    {
      title: "Pets",
      items: [
        "Fishes & Aquarium",
        "Pet Food & Accessories",
        "Dogs",
        "Other Pets",
      ],
    },
    {
      title: "Services",
      items: [
        "Electronics Repair & Services",
        "Education & Classes",
        "Tours & Travel",
        "Health & Beauty",
        "Home Renovation & Repair",
        "Cleaning & Pest Control",
        "Legal & Documentation Services",
        "Packers & Movers",
        "Other Services",
      ],
    },
  ];